exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#customer-choose-pack .modal-dialog{border-radius:0;max-width:1024px}#customer-choose-pack .modal-header{background-color:var(--theme-grey-bg)}#customer-choose-pack .modal-content,#customer-choose-pack .modal-header{border-radius:0}#customer-choose-pack .modal-title{margin:0;text-align:left;font-size:18px}#customer-choose-pack .close{top:15px}#customer-choose-pack .modal-body{padding:20px}", ""]);

// exports
